import React from 'react';
import { Collapse } from '@material-ui/core';
import { getSecondary } from '../../styles/colors';
import { TextInput } from '../../UI';
import ModalTranslate from './ModalTranslate';
import { getText } from '../../utils/functions';
import { NO_FORM_SECTIONS } from '../../utils/constants';

const DEFAULT_VALUE = 'UNDEFINED';
const DEFAULT_TEXT = {
	es: 'UNDEFINED',
	en: 'UNDEFINED',
	gal: 'UNDEFINED',
	cat: 'UNDEFINED',
	eu: 'UNDEFINED',
	fr: 'UNDEFINED',
	pt: 'UNDEFINED',
	pl: 'UNDEFINED'
};

// Setting void('') languages and item void('') values to UNDEFINED
const parsedItem = it => {
	const [languages, setLanguages] = React.useState(it);
	if (languages.value === '') languages.value = DEFAULT_VALUE;

	const newItem = Object.entries(languages.text);
	newItem.forEach(([key, val]) => {
		if (val === '') {
			setLanguages({
				...languages,
				text: {
					...languages?.text,
					[key]: DEFAULT_VALUE
				},
			});
		}
	});
	return languages;
};


const PredefinedPeople = ({
	translate, localState, setLocalState, personType
}) => (
	<div style={{ width: '100%', height: '100%' }}>
		<div>
			<h3 style={{ fontSize: '1.1rem' }}>{getText(personType, translate)}</h3>
		</div>
		<div style={{ paddingRight: '1rem' }}>

			{
				Object.values(localState.config.sections)
					.filter(section => section.isActive
						&& !NO_FORM_SECTIONS.includes(section.value)
						&& (
							section.value === personType.section
							|| localState.config.optionalFields[section.value][personType.section] === true
						)
					)
					.map(section => (
						<CollapseCard
							key={section.value}
							text={`${getText(personType, translate)} ${getText(section, translate)}`}
							section={section.value}
							localState={localState}
							setLocalState={setLocalState}
							personType={personType}
							translate={translate}
						/>
					))
			}
		</div>
	</div>
);
export default PredefinedPeople;

const CollapseCard = ({
	text,
	localState,
	setLocalState,
	section,
	personType,
	translate
}) => {
	const [expandedCard, setExpandedCard] = React.useState(false);

	return (
		<div>
			<div onClick={() => setExpandedCard(!expandedCard)}
				style={{
					display: 'flex',
					alignItems: 'center',
					cursor: 'pointer',
					justifyContent: 'space-between',
					padding: '.5em',
					borderRadius: '4px',
					marginBottom: '.5rem',
					border: '1px solid gainsboro'
				}}
			>
				<div>{text}</div>
				<div>
					<i
						className={'fa fa-angle-down'}
						style={{
							transform: expandedCard ? 'rotate(180deg)' : 'rotate(0deg)',
							transition: 'all 0.3s',
						}}
					/>
				</div>
			</div>
			<Collapse in={expandedCard} timeout="auto" unmountOnExit >
				<div style={{ padding: '.5em', border: '1px solid gainsboro', marginBottom: '.5rem' }}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }} >
						<button
							style={{
								border: `1px solid ${getSecondary()}`,
								borderRadius: '4px',
								padding: '5px',
								color: getSecondary(),
								backgroundColor: 'transparent',
								cursor: 'pointer'
							}}
							onClick={() => {
								setLocalState({
									...localState,
									config: {
										...localState.config,
										predefinedPeople: {
											...localState.config.predefinedPeople,
											[personType.value]: {
												...localState.config.predefinedPeople?.[personType.value],
												[section]: [
													...localState.config
														.predefinedPeople?.[personType.value]?.[section],
													{
														value: DEFAULT_VALUE,
														label: '',
														text: DEFAULT_TEXT
													},
												]
											}
										}
									}
								});
							}}
						>
							Añadir {getText(personType, translate)}
						</button>
					</div>
					<div>
						{localState.config.predefinedPeople[personType.value][section].map((item, index) => (
							<Inputs
								key={`${personType.value}_${section}${index}`}
								translate={translate}
								index={index}
								item={item}
								setLocalState={setLocalState}
								localState={localState}
								personType={personType}
								section={section}
							/>
						))}
					</div>
				</div>
			</Collapse>
		</div >
	);
};

const Inputs = ({
	translate,
	item,
	setLocalState,
	localState,
	index,
	personType,
	section
}) => {
	const [edit, setEdit] = React.useState(false);
	const [rep, setRep] = React.useState(parsedItem(item));

	// Updates rep each time we edit a item
	React.useEffect(() => {
		if (edit === true) setRep(item);
	}, [edit]);

	const changeDelegate = () => {
		const newData = localState.config.predefinedPeople[personType.value][section].map((obj, i) => {
			if (i === index) {
				return {
					...obj,
					...rep
				};
			}
			return obj;
		});
		setLocalState({
			...localState,
			config: {
				...localState.config,
				predefinedPeople: {
					...localState.config.predefinedPeople,
					[personType.value]: {
						...localState.config.predefinedPeople?.[personType.value],
						[section]: [
							...newData
						]
					}
				}
			}
		});
	};

	const removeDelegate = () => {
		const newData = localState.config.predefinedPeople[personType.value][section]
			.filter((val, number) => (number !== index));
		setLocalState({
			...localState,
			config: {
				...localState.config,
				predefinedPeople: {
					...localState.config.predefinedPeople,
					[personType.value]: {
						...localState.config.predefinedPeople?.[personType.value],
						[section]: [
							...newData
						]
					}
				}
			}
		});
	};

	return (
		<div>
			{edit ?
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginTop: '.8em'
				}}>
					<span style={{ fontWeight: 'bold', paddingRight: '5px' }}>
						Texto en portal: {getText(rep, translate)}
					</span>
					<div>
						<ModalTranslate
							translate={translate}
							item={rep}
							name={getText(personType, translate)}
							stylesButton={{ width: '100px' }}
							textButton={'Traducción'}
							setLocalState={newData => setRep({
								...rep,
								...newData
							})}
						/>
					</div>
					<div>
						<TextInput
							floatingText={'Dato enviado a servidor'}
							value={rep.value}
							onChange={ev => {
								setRep({
									...rep,
									value: ev.target.value
								});
							}}
						/>
					</div>
					<div
						style={{
							border: `1px solid ${getSecondary()}`,
							borderRadius: '4px',
							padding: '5px',
							color: getSecondary(),
							backgroundColor: 'transparent',
							marginRight: '.5em',
							cursor: 'pointer'
						}}
						onClick={() => { setEdit(!edit); changeDelegate(); }}
					>
						Añadir
					</div>
				</div>
				:
				<div style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					marginTop: '.8em'
				}}>
					{getText(item, translate) === '' ?
						<div style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%'
						}}
						>
							Persona vacía
						</div>
						:
						<div style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							width: '100%'
						}}
						>
							<div style={{ display: 'flex', width: '50%' }}>
								<div style={{ fontWeight: 'bold', paddingRight: '5px' }}>
									Texto en portal:
								</div>
								<div>{getText(item, translate)}</div>
							</div>
							<div style={{ display: 'flex', width: '50%' }}>
								<div style={{ fontWeight: 'bold', paddingRight: '5px' }}>
									Dato enviado a servidor:
								</div>
								<div>{item.value}</div>
							</div>
						</div>
					}
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div
							style={{
								border: `1px solid ${getSecondary()}`,
								borderRadius: '4px',
								padding: '5px',
								color: getSecondary(),
								backgroundColor: 'transparent',
								marginRight: '.5em',
								cursor: 'pointer'
							}}
							onClick={() => setEdit(!edit)}
						>
							{translate.edit}
						</div>
						<div
							style={{
								border: `1px solid ${getSecondary()}`,
								borderRadius: '4px',
								padding: '5px',
								color: getSecondary(),
								backgroundColor: 'transparent',
								marginRight: '.5em',
								cursor: 'pointer'
							}}
							onClick={() => removeDelegate()}
						>
							Eliminar
						</div>
					</div>
				</div>
			}

		</div >
	);
};
